import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Akmola_obl.png'
import _imports_1 from '@/assets/images/aqmola1.jpg'
import _imports_2 from '@/assets/images/aqmola2.jpg'
import _imports_3 from '@/assets/images/aqmola3.jpg'
import _imports_4 from '@/assets/images/aqmola4.jpg'
import _imports_5 from '@/assets/images/aqmola5.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Акмолинская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Акмолинская область – «магнит» для туристов. Путешественники одинаково охотно посещают и центр региона, экономически развитый город Кокшетау, и природные достопримечательности, которые окружают его со всех сторон. Здесь есть что посетить! Горы, шикарные хвойные леса, красивейшие озера. А еще сюда едут, чтобы поправить свое здоровье – именно в Акмолинской области функционирует известная далеко за пределами Казахстана круглогодичная Щучинско-Боровская курортная зона. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Состояние Отрасли")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Как развивается туризм в Акмолинской области? Регион входит в ТОП-5 лидеров туристических зон Казахстана. Здесь функционируют более 700 профильных организаций , из них – почти 50 санаторно-курортных заведений, около 200 объектов придорожного сервиса. "),
        /*#__PURE__*/_createVNode("p", null, " В регионе около тысячи культурно-исторических памятников, и большинство из них входят в экскурсионные программы. Путешественникам предлагается порядка 80 типовых туристских маршрутов и немало оригинальных программ от местных туркомпаний. "),
        /*#__PURE__*/_createVNode("p", null, " Основу турпотока составляют местные туристы, утверждает статистика туризма Акмолинской области, однако в 2019 году регион посетило и немалое число иностранцев. ")
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "13573")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "17,0")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "376434")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "18501")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "«Зеленый» Туризм")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " В последние годы в стране – бум популярности экотуризма. Если цель экопутешественника – полюбоваться природой, региону и здесь есть что предложить. Национальный парк «Бурабай» с 14 крупными озерами, включая знаменитое Боровое, и национальный парк «Кокшетау» со множеством живописных водоемов, среди которых древнее озеро Зеренда. В другом национальном парке – «Буйратау» – можно наблюдать маралов в их естественных условиях обитания, а в Коргалжынском заповеднике – большие стаи фламинго. Перспективное направление природного туризма сегодня – организация орнитологических экскурсий весной и осенью на местные водно-болотные угодья. Кроме фламинго, здесь можно наблюдать и других интересных птиц, например, кудрявого пеликана, кречетку, черного жаворонка. Это можно взять на вооружение компаниям, чье направление деятельности – внутренний туризм, статистика показывает, что казахстанцам такие поездки очень интересны. ")
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, " Перспективы Туристической Отрасли В Регионе ")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, " Необычный климат в Акмолинской области привлекает в эти места европейских туристов, так утверждает статистика по туризму региона. С мая по октябрь погода располагает к прогулкам по горам и лесам, пляжному отдыху на озерах, сбору грибов и ягод. Зимой температура опускается до -25…-30℃, и это отличный период для активного отдыха: катания на лыжах, сноубордах и коньках. Также перспективными являются туры по организации подледной рыбалки. ")
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col" }
const _hoisted_10 = { class: "regio-swiper" }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}